/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HomeownershipLastLookAnswer = {
    Match: 'match',
    Pass: 'pass',
    NoReply: 'no_reply'
} as const;
export type HomeownershipLastLookAnswer = typeof HomeownershipLastLookAnswer[keyof typeof HomeownershipLastLookAnswer];


export function HomeownershipLastLookAnswerFromJSON(json: any): HomeownershipLastLookAnswer {
    return HomeownershipLastLookAnswerFromJSONTyped(json, false);
}

export function HomeownershipLastLookAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipLastLookAnswer {
    return json as HomeownershipLastLookAnswer;
}

export function HomeownershipLastLookAnswerToJSON(value?: HomeownershipLastLookAnswer | null): any {
    return value as any;
}

